// @flow

type StringSearcher<T> = (search: string, list: T[]) => T[];

export const stringsMatchSearch = (
  search: string,
  strings: string[],
): boolean =>
  strings.some((s) => (s || '').toLowerCase().includes(search.toLowerCase()));

export const stringSearcher =
  <T>(stringsFinder: (T) => string[]): StringSearcher<T> =>
  (search: string, list: T[]): T[] =>
    search.trim()
      ? list.filter((item) => stringsMatchSearch(search, stringsFinder(item)))
      : list;
